import React from 'react';

interface BarcodeProps {
  children: string;
}

function parseBarcode(barcode: string) {
  const d = barcode.replace(/\D/g, '');
  if (d.length === 13) return { prefix: d.slice(0, 7), boxId: d.slice(7) };
  if (d.length === 12) return { prefix: d.slice(0, 7), boxId: d.slice(7) };
  return { prefix: d.slice(0, -4), boxId: d.slice(-4) };
}

export default function Barcode({ children }: BarcodeProps): JSX.Element {
  const { prefix, boxId } = parseBarcode(children);

  return (
    <span className="barcode-display">
      <span className="barcode-prefix">{prefix}</span>
      <span className="barcode-boxid">{boxId}</span>
    </span>
  );
}
